angular.module('app')
    .directive('textScrollingEffect', textScrollingEffect)

textScrollingEffect.$inject = [];
function textScrollingEffect() {
    return {
        restrict: 'EA',
        link: link,
        template: ''
    }

    function link(scope, element, attrs) {
        const container = angular.element(element);
        const textElements = container.find('li');

        var isMobile = window.matchMedia("only screen and (max-width: 1023px)").matches;

        if (!isMobile) {
            const scrollMagicCtrl = new ScrollMagic.Controller();

            for (var indx = 0; indx < textElements.length; indx++) {
                new ScrollMagic.Scene({
                    triggerElement: textElements[indx]
                })
                    //.addIndicators({ name: 'section-' + indx })
                    .on('start', function(event) {
                        const triggerElement = angular.element(event.target.triggerElement());
                        event.target.duration(triggerElement.outerHeight(true));
                    })
                    .on('enter', function (event) {
                        const triggerElement = event.target.triggerElement();
                        new TimelineMax()
                            .to(triggerElement, 0.5, { opacity: 1, ease: Power4.easeInOut })
                            .add(setTween(event.target.triggerElement(), false), '-=0.5')
                            /*.to(prevElem, 0.5, { opacity: firstOpacity, ease: Power4.easeInOut }, '-=0.5')
                            .to(nextElem, 0.5, { opacity: firstOpacity, ease: Power4.easeInOut }, '-=0.5')
                            .to(prevElem.prev(), 0.5, { opacity: secondOpacity, ease: Power4.easeInOut }, '-=0.5')
                            .to(nextElem.next(), 0.5, { opacity: secondOpacity, ease: Power4.easeInOut }, '-=0.5')*/
                            
                    })
                    .on('leave', function (event) {
                        const triggerElement = event.target.triggerElement();
                        new TimelineMax()
                            .to(triggerElement, 0.5, { opacity: 0.1, ease: Power4.easeInOut })
                            .add(setTween(event.target.triggerElement(), true), '-=0.5')
                            /*.to(prevElem, 0.5, { opacity: 0.1, ease: Power4.easeInOut }, '-=0.5')
                            .to(nextElem, 0.5, { opacity: 0.1, ease: Power4.easeInOut }, '-=0.5')
                            .to(prevElem.prev(), 0.5, { opacity: 0.1, ease: Power4.easeInOut }, '-=0.5')
                            .to(nextElem.next(), 0.5, { opacity: 0.1, ease: Power4.easeInOut }, '-=0.5')*/
                    })
                    .addTo(scrollMagicCtrl);
            }
        }

        function setTween(triggerElement, isReset) {
            const currentElementIndex = textElements.index(triggerElement);
            const offsetElements = 2;
            const firstOpacity = 0.45;
            const secondOpacity = 0.2;

            const tweenScroll = new TimelineMax();
            let isFirst = true;
            //set animation above the element
            for (let index = currentElementIndex - 1; index >= (currentElementIndex - offsetElements) ; index--) {
                //console.log(index, index >= (currentElementIndex - offsetElements), textElements[index]);
                if (textElements[index]) {
                    tweenScroll.to(textElements[index], 0.5, {
                        opacity: isReset ? 0.1 : isFirst ? firstOpacity : secondOpacity,
                        ease: Power4.easeInOut
                    }, '-=0.5')
                    isFirst = false;
                }
            }

            isFirst = true;
            for (let index = currentElementIndex + 1; index <= (currentElementIndex + offsetElements) ; index++) {
                if (textElements[index]) {
                    tweenScroll.to(textElements[index], 0.5, {
                        opacity: isReset ? 0.1 : isFirst ? firstOpacity : secondOpacity,
                        ease: Power4.easeInOut
                    }, '-=0.5')
                    isFirst = false;
                }
            }

            return tweenScroll;
        }
    }
}